export const VALUE_TOLERANCE = 0.009;

export function withinBalance(amount, balance) {
    return amount <= balance + VALUE_TOLERANCE;
}

export function costCenterType(type) {
    return type == 1 ? 2 : 1;
}

export default {
    computed: {
        valueTolerance() {
            return VALUE_TOLERANCE;
        },
        otherPairedCount() {
            if (!this.recordItem || !this.recordItem.pairIds) return 0;
            return Math.max(this.recordItem.pairIds.length - 1, 0);
        },
        hasOtherPairedItems() {
            return this.otherPairedCount > 0;
        },
        linkedStatementItems() {
            if (!this.statement || !this.recordItem || !this.recordItem.pairIds) return [];
            return this.statement.filter((item) => this.recordItem.pairIds.includes(item.id));
        },
        existingPaidAmount() {
            if (!this.recordItem) return 0;
            return Math.max(Math.abs(this.recordItem.value) - this.recordItem.baseRemainingValue, 0);
        },
        hasExistingBalance() {
            return this.existingPaidAmount > VALUE_TOLERANCE;
        },
    },
};
